
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/district-reviews",
      function () {
        return require("private-next-pages/district-reviews/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/district-reviews"])
      });
    }
  